import React from 'react';

import combinedActions from '~redux/combinedActions';
import { useAppDispatch, useAppSelector } from '~redux/hooks';
import { initialState as reportInitialState } from '~redux/slices/report';

import SearchAndFilterBar, { TSearchAndFilterBarProps } from '~components/molecules/SearchAndFilterBar';

import { FundTypeEnum } from '~utils/enums';

import * as Styles from './InventoryReportSummarySearchAndFilterBar.module.scss';
import { TGetInventoryReportTransactionSummaryFilters } from '~types/feat/report';

const InventoryReportSummarySearchAndFilterBar = () => {
    const dispatch = useAppDispatch();
    const filters = useAppSelector(state => state.report.inventoryReport.inventoryReportFiltersSummary);
    const { allBranchAccess, branchCode } = useAppSelector(state => state.auth.userDetails);
    const initialFilters = reportInitialState.inventoryReport.inventoryReportFiltersSummary;
    const branchesList = useAppSelector(state => state.branch.allBranches);

    const setFilters = (inputFilters: TGetInventoryReportTransactionSummaryFilters) => dispatch(combinedActions.reportSetInventoryReportTransactionSummaryFilters(inputFilters));
    const handleSearchClick = () => {
        dispatch(combinedActions.reportGetInventoryReportCardSummaryAttempt());
    };
    const handleCancelClick = () => {
        const resetFilters = {
            ...initialFilters,
            branchName: !allBranchAccess
                ? (branchesList.find(branch => branch.branchCode === branchCode)?.branchName || '')
                : '',
        };

        setFilters(resetFilters);
        dispatch(combinedActions.reportGetInventoryReportCardSummaryAttempt());
    };

    const fields: TSearchAndFilterBarProps['fields'] = [
        {
            label: 'Fund Type:',
            type: 'dropdown' as const,
            dropdownParams: {
                options: [
                    {
                        label: 'Islamic',
                        value: 'Islamic',
                    },
                    {
                        label: 'Conventional',
                        value: 'Conventional',
                    },
                ],
                value: FundTypeEnum[filters.fundType ?? FundTypeEnum.Islamic],
                setValue: (event: React.ChangeEvent<HTMLInputElement>) =>
                    setFilters({
                        ...filters,
                        fundType: FundTypeEnum[
                            event.target.value as keyof typeof FundTypeEnum
                        ] as FundTypeEnum,
                    }),
                optionSelected: true,
                noOptionsMessage: 'No fund type found',
                className: Styles.input,
            },
        },
    ];

    return (
        <SearchAndFilterBar
            fields={fields}
            searchOnClick={handleSearchClick}
            cancelOnClick={handleCancelClick}
            containerClassName={Styles['content-container']}
            // gridColumns={4}
        />
    );
};

export default InventoryReportSummarySearchAndFilterBar;
